import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ViewUsers from './ViewUsers/ViewUsers';
import UserTypes from './UserTypes/UserTypes';
import Input from '../../components/Input/Input';
import Loader from '../../components/Loader/Loader';
import { createUserTypeIcon } from '../../assets/Icons/Icons';
import { AccountInfoSP } from '../PageLayout/PageLayout';
import {
    selectAllUsers,
    selectUserSearch,
    setUserSearch,
    setIsCreateUserType,
    selectIsCreateUserType,
    getUserTypes,
    selectUserTypesLoadingStatus
} from '../../store/delegationOfAuthoritySlice';
import {
    setSidePanelTitle,
    setAdminPortalView,
    selectAdminPortalView,
    selectRole,
    setSidePanelOptions,
    selectSidePanelTitle
} from '../../store/pageLayoutSlice';
import './AdminPortal.css';

function AdminPortal(props){
    // const dispatch = useDispatch();
    // useEffect(()=>{
    //     dispatch( getUserTypes({app: "hdmi"}) );
    // }, [dispatch])

    const { users, userTypes } = useSelector( selectAdminPortalView );
    const { userTypesLoadingStatus } = useSelector( selectUserTypesLoadingStatus );

    return (
        <div id="admin_portal_wrapper">
            { users && <ViewUsers /> }
            { userTypes && <UserTypes />}
            { userTypesLoadingStatus === 'loading' && <Loader /> }
        </div>
    );
}

const AdminPortalSPC = props =>{

    const dispatch = useDispatch();
    const { users } = useSelector( selectAdminPortalView );
    const adminUserRole = useSelector( selectRole );
    const isCreateUserType = useSelector( selectIsCreateUserType );
    const userList = useSelector( selectAllUsers );
    const sidePanelTitle = useSelector( selectSidePanelTitle );
    const { name, role, userType, userStatus } = useSelector( selectUserSearch );

    const {
        userNameOptions,
        roleOptions,
        userTypeOptions,
        userStatusOptions
    } = useMemo(() => {
        let names = [];
        let roles = [];
        let userTypes = [];
        let statuses = [];
        userList.forEach( user =>{
            names.push(user.userName);
            roles.push(user.role);
            userTypes.push(user.userType);
            statuses.push(user.userStatus);
        });
        roles = [ ...new Set(roles) ];
        userTypes = [ ...new Set(userTypes) ];
        statuses = [ ...new Set(statuses) ];
        return {
            userNameOptions: names,
            roleOptions: roles,
            userTypeOptions: userTypes,
            userStatusOptions: statuses
        };
    }, [ userList ]);
    
    useEffect(() => {
        dispatch( setSidePanelTitle('Manage') )
        dispatch( setSidePanelOptions( ['Manage','Account'] ) );
    }, [ dispatch ]);

    return (
        <div className="admin_portal_sp_wrapper">
            {
                sidePanelTitle === 'Manage' &&
                <>
                    <div className="admin_portal_sp_link_container">
                        <button
                            className={ users ? "admin_portal_sp_link admin_portal_link_active" : "admin_portal_sp_link"}
                            onClick={ () => dispatch( setAdminPortalView('users') ) }
                        >
                            Users
                        </button>
                    </div>
                    <div className="admin_portal_sp_link_container">
                        <button
                            className={ users ? "admin_portal_sp_link" : "admin_portal_sp_link admin_portal_link_active"}
                            onClick={ () => dispatch( setAdminPortalView('userTypes') ) }
                        >
                            User Types
                        </button>
                    </div>
                    <div className="admin_portal_sp_content">
                        {
                            (users) &&
                            <div className="admin_portal_sp_search_container">
                                <div>
                                    <h3 className="side_panel_title">
                                        Search
                                    </h3>
                                </div>
                                <div className="admin_portal_sp_input_container">
                                    <Input 
                                        type="searchable"
                                        value={ name }
                                        handleChange={ 
                                            (e) => dispatch( setUserSearch({ field: 'name', value: e.target.value }) )
                                        }
                                        handleSelect={
                                            (e) => dispatch( setUserSearch({ field: 'name', value: e.target.textContent }) )
                                        }
                                        handleClearValue={
                                            () => dispatch( setUserSearch({ field: 'name', value: '' }) )
                                        }
                                        options={ userNameOptions }
                                        placeHolder="User Name"
                                    />
                                </div>
                                <div className="admin_portal_sp_input_container">
                                    <Input 
                                        type="searchable"
                                        value={ userType }
                                        handleChange={ 
                                            (e) => dispatch( setUserSearch({ field: 'userType', value: e.target.value }) )
                                        }
                                        handleSelect={
                                            (e) => dispatch( setUserSearch({ field: 'userType', value: e.target.textContent }) )
                                        }
                                        handleClearValue={
                                            () => dispatch( setUserSearch({ field: 'userType', value: '' }) )
                                        }
                                        options={ userTypeOptions }
                                        placeHolder="User Type"
                                    />
                                </div>
                                <div className="admin_portal_sp_input_container">
                                    <Input 
                                        type="searchable"
                                        value={ userStatus }
                                        handleChange={ 
                                            (e) => dispatch( setUserSearch({ field: 'userStatus', value: e.target.value }) )
                                        }
                                        handleSelect={
                                            (e) => dispatch( setUserSearch({ field: 'userStatus', value: e.target.textContent }) )
                                        }
                                        handleClearValue={
                                            () => dispatch( setUserSearch({ field: 'userStatus', value: '' }) )
                                        }
                                        options={ userStatusOptions }
                                        placeHolder="User Status"
                                    />
                                </div>
                                <div className="admin_portal_sp_input_container">
                                    <Input 
                                        type="searchable"
                                        value={ role }
                                        handleChange={ 
                                            (e) => dispatch( setUserSearch({ field: 'role', value: e.target.value }) )
                                        }
                                        handleSelect={
                                            (e) => dispatch( setUserSearch({ field: 'role', value: e.target.textContent }) )
                                        }
                                        handleClearValue={
                                            () => dispatch( setUserSearch({ field: 'role', value: '' }) )
                                        }
                                        options={ roleOptions }
                                        placeHolder="User Role"
                                    />
                                </div>
                            </div>
                        }
                        {
                            (!users && adminUserRole === 'Super Admin') &&
                            <div className="admin_portal_sp_doa_container">
                                <h3 className="admin_portal_sp_title">Actions</h3>
                                <div className="admin_portal_sp_create_button_container">
                                    <button
                                        className="create_user_type_button"
                                        onClick={ () => dispatch( setIsCreateUserType(true) ) }
                                        disabled={ isCreateUserType }
                                    >
                                        { createUserTypeIcon }
                                        <span className="create_user_type_button_text">Create User Type</span>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </>
            }
            {
                sidePanelTitle === 'Account' &&
                <AccountInfoSP />
            }
        </div>
    );
}

export default AdminPortal;

export { AdminPortalSPC };